module.exports = __webpack_public_path__ + "img/logo_jamaica.84c4df31.png";